// utils/slugify.js
export const slugify = (str = "") =>
  str
    .toLowerCase()
    .replace(/[\s&/]+/g, "-")
    .replace(/-+/g, "-")
    .trim();
